module.exports = __webpack_public_path__ + "media/landing_page/household-a47d1d9e.png";